goog.provide('el8.util.dom');

goog.require('el8.util.consts');

el8.util.dom = (function() {

    return {

        openBackgroundTab: function(url) {
            // Behavior simulates opening in a new tab, but re-focuses this tab
            // The formerly used technique stopped working in Chrome 41. This works
            // in all browsers, but results in briefly changing tabs to the new url
            // and then back again.
            window.open(url);
            window.focus();
        },

        isInView: function( $obj, $container, topOffset, leftOffset ) {
            var objTop = $obj.offset().top + (topOffset || 0);
            var objBottom = objTop + $obj.height();
            var objLeft = $obj.offset().left + (leftOffset || 0);
            var objRight = objLeft + $obj.width();
            if( $container ) {
                // If container specified, check both vertical and horizontal views
                var docViewTop = $container.offset().top;
                var docViewBottom = docViewTop + $container.height();
                var docViewLeft = $container.offset().left;
                var docViewRight = docViewLeft + $container.width();
                return ( (objBottom >= docViewTop) && (objTop <= docViewBottom) && (objLeft <= docViewRight) && (objRight >= docViewLeft) );
            } else {
                // Otherwise, just need to check vertical view with window
                var docViewTop = $(window).scrollTop();
                var docViewBottom = docViewTop + $(window).height();
                return (( objBottom >= docViewTop ) && ( objTop <= docViewBottom ));
            }
        },

        isAboveTop: function($obj, $container) {
            var objBottom = $obj.offset().top + $obj.height();
            var docViewTop = $container ? $container.offset().top : $(window).scrollTop();
            return (objBottom < docViewTop);
        },

        isBelowBottom: function($obj, $container) {
            var objTop = $obj.offset().top;
            var docViewBottom = $container ? $container.offset().top + $container.height() :
                $(window).scrollTop() + $(window).height();
            return (objTop > docViewBottom);
        },

        moveCursor: function(domField, start, end) {
            if (!end) { end = start; }
            return domField.each(function(index) {
                try {
//#JSCOVERAGE_IF
                    if (this.createTextRange) {
                        var range = this.createTextRange();
                        range.collapse(true);
                        range.moveEnd('character', end);
                        range.moveStart('character', start);
                        range.select();
                    } else if (this.setSelectionRange) {
                        this.setSelectionRange(start, end);
                    }
                } catch (err) {
                }
            });
        },

        isCursorAtEnd: function(field, infoText) {
            var val = infoText ? field.value.replace(infoText, '') : field.value;
            return (field.selectionEnd === val.length);
        },

        isCursorAtStart: function(field) {
            return (field.selectionStart === 0);
        },

        adjustTextareaHeight: function($ta, $wrapper) {
            var newHeight = $ta[0].scrollHeight;
            var currentHeight = $ta[0].clientHeight;
            if (newHeight > currentHeight) {
                $ta.height(newHeight);
                if ($wrapper) { $wrapper.height(newHeight); }
            }
        },

        /*
         * Adapted from https://gist.github.com/2106862
         *
         * Traditionally the shadow element is a <div>... I'm not sure why we
         * use a <textarea>. Basically, though, this works by creating a hidden
         * version of the textarea with the same content and then using its
         * browser-calculated scrollHeight to adjust the height of $ta.
         *
         * $wrapper is a <div> or some other container around $ta, which needs
         * to be manually given the same height as our textarea.
         */
        growShrinkTextarea: function($ta, $wrapper, minHeight) {
            minHeight = (minHeight || el8.util.consts.DEFAULT_FIELD_HEIGHT)*1;
            var shadow = $ta.next('textarea.shrink');
            if (!shadow.length) {
                shadow = $('<textarea>').css({
                    position:   'absolute',
                    resize:     'none'
                }).insertAfter($ta).addClass('shrink')
                  .attr('title', '').attr('tabindex', '-1');
            }
            shadow.css({
                top:        -50000,
                left:       -50000,
                fontSize:   $ta.css('fontSize'),
                fontFamily: $ta.css('fontFamily'),
                overflow:   'hidden'
            });
            if ($ta.attr('height')) {
                shadow.height($ta.attr('height'));
            }
            var width = $ta.width();
            shadow.outerWidth(width);
            var val = $ta.val();
            if (val === $ta.attr('_infotext')) { val = ''; }
            shadow.val(val);

            var scrollHeight = shadow[0].scrollHeight;
            if ($ta.css('box-sizing') === 'border-box') {
                // If we're using border-box, any vertical padding is part of our height.
                // This prevents us from overflowing our contianer via padding, but it
                // also means we need to leave room for our content + padding in our new height.
                var verticalPadding = $ta.outerHeight() - $ta.height();
                if (verticalPadding > 0) {
                    scrollHeight += verticalPadding;
                }
            }
            var newHeight = Math.max(scrollHeight, minHeight);
            $ta.height(newHeight);
            if ($wrapper) { $wrapper.height(newHeight); }
        }

    };

})();
